export interface SessionItemData {
  id?: number;
  type?: string;
  sessionItemWrapperId?: number;
  restTime?: number;
  comment?: string;
  ord?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}

export class SessionItem {
  public static readonly TYPE_REST: string = 'REST';
  public static readonly TYPE_COMMENT: string = 'COMMENT';

  public static getNonTranslatableFields(): string[] { return ['id', 'type', 'sessionItemWrapperId', 'restTime', 'comment', 'ord', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'type', 'sessionItemWrapperId', 'restTime', 'comment', 'ord', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  type?: string;
  sessionItemWrapperId?: number;
  restTime?: number;
  comment?: string;
  ord?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;


  public static fromAPI(data: SessionItemData): SessionItem {
    return new SessionItem(data);
  }

  public static fromAPIList(data: SessionItemData[]): SessionItem[] {
    return data.map((item) => SessionItem.fromAPI(item));
  }

  constructor({id, type, sessionItemWrapperId, restTime, comment, ord, createDate, createrId, updateDate, updaterId, deleteDate, deleterId} : SessionItemData) {
    this.id = id;
    this.type = type;
    this.sessionItemWrapperId = sessionItemWrapperId;
    this.restTime = restTime;
    this.comment = comment;
    this.ord = ord;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): SessionItemData {
    return {
      id: this.id,
      type: this.type,
      sessionItemWrapperId: this.sessionItemWrapperId,
      restTime: this.restTime,
      comment: this.comment,
      ord: this.ord,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
